import React from "react";
import { motion } from "framer-motion";

interface AnimatedPulseProps {
  settings: {
    size?: number; // Base size in pixels
    count?: number; // Number of pulse rings
    duration?: number; // Animation duration in seconds
    colors?: string[]; // Array of color values for animation
    borderWidth?: number; // Border width in pixels
    maxScale?: number; // Maximum scale the pulse will grow to
    delayOffset?: number; // Delay between each pulse ring in seconds
    className?: string; // Additional className for the container
    isMultiColor?: boolean; // Flag to indicate if multiple colors are used
  };
}

export const AnimatedPulse = ({ settings }: AnimatedPulseProps) => {
  // Default values with fallbacks
  const {
    size = 200, 
    count = 4,
    duration = 3,
    colors = ["#e3dbc8", "#899B30", "#AC7E4C", "#D6CFF8", "#e3dbc8"],
    borderWidth = 2,
    maxScale = 3,
    delayOffset = 2, // Slightly longer delay for more apparent staggering
    className = "",
    isMultiColor = false,
  } = settings;

  // Create array of specified length to map over
  const pulses = Array.from({ length: count }, (_, i) => i);

  return (
    <div className={`absolute flex items-center justify-center ${className} h-full w-full`}>
      {pulses.map((_, i) => (
        <motion.div 
          key={i}
          className="absolute rounded-full bg-transparent"
          style={{
            width: `${size}px`,
            height: `${size}px`,
            border: `${borderWidth}px solid ${isMultiColor ? colors[i % colors.length] : colors[0] || "#e3dbc8"}`,
          }}
          initial={{ scale: 1, opacity: 0 }}
          animate={{
            scale: [1, 1.2, maxScale],
            opacity: [0, 0.8, 0], 
          }}
          transition={{
            duration: duration,
            repeat: Infinity,
            repeatType: "loop",
            ease: "easeOut", // Changed from linear to easeOut for smoother end
            delay: (i * delayOffset / count),
            times: [0, 0.1, 1], // Better distribution: start invisible, fade in quickly, then fade out
          }}
        />
      ))}
      
      {/* Optional center content slot */}
      <div className="relative">
        {/* Content inside the pulse can be added here */}
      </div>
    </div>
  );
};

export default AnimatedPulse;